import { clearApiSession, configureApiSession, setApiAccessToken } from "./api";
import {
  clearSessionTokens,
  getStoredAccessToken,
  refreshSessionAccessToken,
  storeSessionTokens
} from "./authSession";

export function initializeAuthSession() {
  const storedAccessToken = getStoredAccessToken();
  if (storedAccessToken) {
    setApiAccessToken(storedAccessToken);
  }
  configureApiSession({
    getAccessToken: getStoredAccessToken,
    refreshAccessToken: refreshSessionAccessToken
  });
}

export function applyLoginSession({ accessToken, refreshToken, persist = true } = {}) {
  storeSessionTokens({ accessToken, refreshToken, persist });
  setApiAccessToken(accessToken || null);
}

export function updateAccessSessionToken(accessToken) {
  setApiAccessToken(accessToken || null);
}

export function logoutAuthSession() {
  clearSessionTokens();
  clearApiSession();
}
